import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Tour from "~/models/Tour";
import ErrorPage from "~/components/element/ErrorPage";
import TourNav from "../constants/TourNav";

const accessAllowed = (tourAcl, active) => {
  switch (active) {
    case "":
      return true;
    case TourNav.ADDRESS:
      return tourAcl.address;
    case TourNav.MLS:
      return tourAcl.mls;
    case TourNav.INFO:
      return tourAcl.info;
    case TourNav.MEDIA_EDIT:
      return tourAcl.mediaEdit;
    case TourNav.MEDIA_SETTINGS:
      return tourAcl.mediaSettings;
    case TourNav.SETTINGS:
      return tourAcl.settings;
    case TourNav.STATS:
      return tourAcl.stats;
    case TourNav.LINKS:
      return tourAcl.links;
    case TourNav.FLYER:
      return tourAcl.flyer;
    case TourNav.DOWNLOAD:
      return tourAcl.download;
    case TourNav.VIDEO:
      return tourAcl.videoRequest;
    case TourNav.IMMERSIVE_3D_TOUR:
      return tourAcl.immersive3dTour;
    case TourNav.UI_MEET_3D:
      return tourAcl.uiMeet3d;
    case TourNav.RANSOM_REVIEW:
      return tourAcl.ransomReview;
    default:
      throw new Error(`Unexpected active tour page: ${active}`);
  }
};

const TourAcl = observer(({ tour, active, children, t }) => {
  if (tour && tour.acl && !accessAllowed(tour.acl, active)) {
    return (
      <ErrorPage
        title={t("clientPanelMisc:notAllowed")}
        helpText={t("clientPanelMisc:cannotBeDisplayedTourConfiguration")}
        continueUrl="/tours"
        continueText={t("myTours")}
      />
    );
  }

  return children;
});

TourAcl.propTypes = {
  tour: PropTypes.instanceOf(Tour),
  active: PropTypes.string,
};

TourAcl.defaultProps = {
  tour: null,
  active: "",
};

export default withTranslation()(TourAcl);
